module.exports = __webpack_public_path__ + "img/30_photo.7d2ee45e.png";